<button [routerLink]="'/organizationuser'" [queryParams]="{userId: item.user.id, orgId: item.organization.id}" *ngFor="let item of organizationUsers"> 
    {{item.user.name}}
 </button>

 